import BlogCollectionPill from "./BlogCollectionPill";

export default BlogCollectionPill;
